import { FC } from 'react'
import { Typography } from '@material-tailwind/react'
import { colors } from '@material-tailwind/react/types/generic'
import { AddAgamiToExpRow } from './AddAgamiToExpRow'
import { AgamiSpot } from '../types/supabase'

const TABLE_HEAD = ['Agami Name', 'Description', 'Type', 'Last update', 'Add to experience']

interface AddAgamiToExperienceTableProps {
  currentExpId: string
  refetchAfterChange: () => Promise<void>
  agamiList: AgamiSpot[]
}

export const AddAgamiToExperienceTable: FC<AddAgamiToExperienceTableProps> = ({
  currentExpId,
  refetchAfterChange,
  agamiList,
}) => (
  <table className="w-full">
    <thead>
      <tr>
        {TABLE_HEAD.map((head) => (
          <th
            key={head}
            className="border-blue-gray-100 bg-blue-gray-500/30 dark:bg-primary-600 border-b p-4"
          >
            <Typography variant="small" color={'primary' as colors} className="font-bold leading-none">
              {head}
            </Typography>
          </th>
        ))}
      </tr>
    </thead>
    <tbody>
      {agamiList.map(({ id, name, description, type, inserted_at, experience_content_spots }) => (
        <AddAgamiToExpRow
          key={id}
          id={id}
          name={name}
          description={description}
          type={type}
          updated_at={inserted_at}
          experience_content_spots={experience_content_spots}
          currentExpId={currentExpId}
          refetch={refetchAfterChange}
        />
      ))}
    </tbody>
  </table>
)
